__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "bbas";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@cxc/react-connected-components", "0.118.6", () => (__webpack_require__.e(9169).then(() => (() => (__webpack_require__(9169))))));
			register("@cxc/react-universal-components", "0.75.43", () => (() => (__webpack_require__(1678))), 1);
			register("@emotion/react", "11.14.0", () => (() => (__webpack_require__(9646))), 1);
			register("@emotion/styled", "11.14.1", () => (() => (__webpack_require__(8202))), 1);
			register("@reduxjs/toolkit", "2.12.0", () => (() => (__webpack_require__(8740))), 1);
			register("@ucl/context", "6.12.0", () => (() => (__webpack_require__(2116))), 1);
			register("dompurify", "3.4.15", () => (__webpack_require__.e(4997).then(() => (() => (__webpack_require__(4997))))));
			register("escape-html", "1.0.3", () => (__webpack_require__.e(580).then(() => (() => (__webpack_require__(580))))));
			register("fuse.js", "7.5.0", () => (__webpack_require__.e(2384).then(() => (() => (__webpack_require__(2384))))));
			register("html-react-parser", "5.2.17", () => (__webpack_require__.e(3200).then(() => (() => (__webpack_require__(3200))))));
			register("i18next-browser-languagedetector", "7.2.2", () => (__webpack_require__.e(8527).then(() => (() => (__webpack_require__(8527))))));
			register("i18next-resources-to-backend", "1.2.3", () => (__webpack_require__.e(6332).then(() => (() => (__webpack_require__(6332))))));
			register("i18next", "23.16.8", () => (__webpack_require__.e(2526).then(() => (() => (__webpack_require__(2526))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-helmet", "6.1.0", () => (__webpack_require__.e(1465).then(() => (() => (__webpack_require__(1465))))));
			register("react-hook-form", "7.87.0", () => (__webpack_require__.e(4905).then(() => (() => (__webpack_require__(7286))))));
			register("react-i18next", "14.1.3", () => (__webpack_require__.e(4746).then(() => (() => (__webpack_require__(2365))))));
			register("react-markdown", "10.1.0", () => (Promise.all([__webpack_require__.e(6694), __webpack_require__.e(4613)]).then(() => (() => (__webpack_require__(4613))))));
			register("react-redux", "8.1.3", () => (() => (__webpack_require__(363))), 1);
			register("react-router-dom", "6.30.6", () => (() => (__webpack_require__(4976))), 1);
			register("react-router", "6.30.6", () => (() => (__webpack_require__(7767))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			register("remark-gfm", "4.0.1", () => (Promise.all([__webpack_require__.e(6694), __webpack_require__.e(5405)]).then(() => (() => (__webpack_require__(5405))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};